<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-user-check'}"
	[headerText]="data.trainingRoom.name + (T.ROOM_PLAYER_SELECTION_DIALOG_HEADER_SUFFIX | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="row">
			<div class="col-lg-4 col-md-4 col-sm-4">
				<h3>
					{{ T.CONFIGURATION_EDITOR_TRAININGROOM_HEADER_DEBRIEFING_PLAYERS | translate }}
				</h3>
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getPlayerName"
					(removeEntryEmitter)="removeDebriefingPlayer($event)"
					[scrollEntries]="usedDebriefingPlayerList ?? filterUsedDebriefingPlayerList()"
				>
					<mat-form-field color="accent" style="width: 100%; justify-items: center">
						<mat-label>
							{{ T.CONFIGURATION_EDITOR_TRAINING_ROOM_ASSIGNED_PLAYERS | translate }}
						</mat-label>
						<mat-select
							(ngModelChange)="addDebriefingPlayer($event)"
							[(ngModel)]="selectedDebriefingPlayer"
							style="width: 100%"
						>
							@for (player of availableDebriefingPlayerList ?? filterAvailableDebriefingPlayerList(); track player) {
								<mat-option [value]="player">
									{{ player.name }}
								</mat-option>
							}
							<mat-option [value]="null">{{ T.CONFIGURATION_EDITOR_TRAININGROOM_NO_PLAYER | translate }}</mat-option>
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-4">
				<h3>
					{{ T.CONFIGURATION_EDITOR_TRAININGROOM_HEADER_MEDIASCREEN_PLAYERS | translate }}
				</h3>
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getPlayerName"
					(removeEntryEmitter)="removeMediaScreenPlayer($event)"
					[scrollEntries]="usedMediaScreenPlayerList ?? filterUsedMediaScreenPlayerList()"
				>
					<mat-form-field color="accent" style="width: 100%; justify-items: center">
						<mat-label>{{ T.CONFIGURATION_EDITOR_TRAINING_ROOM_ASSIGNED_PLAYERS | translate }}</mat-label>
						<mat-select
							(ngModelChange)="addMediaScreenPlayer($event)"
							[(ngModel)]="selectedMediaScreenPlayer"
							style="width: 100%"
						>
							@for (player of availableMediaScreenPlayerList ?? filterAvailableMediaScreenPlayerList(); track player) {
								<mat-option [value]="player">
									{{ player.name }}
								</mat-option>
							}
							<mat-option [value]="null">{{ T.CONFIGURATION_EDITOR_TRAININGROOM_NO_PLAYER | translate }}</mat-option>
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-4">
				<h3>
					{{ T.CONFIGURATION_EDITOR_TRAININGROOM_HEADER_DIGITALSIGNAGE_PLAYERS | translate }}
				</h3>
				<sim-admin-settings-scroll-entries-con
					[getScrollEntryText]="getPlayerName"
					(removeEntryEmitter)="removeDigitalSignagePlayer($event)"
					[scrollEntries]="usedDigitalSignagePlayerList ?? filterUsedDigitalSignagePlayerList()"
				>
					<mat-form-field color="accent" style="width: 100%; justify-items: center">
						<mat-label>{{ T.CONFIGURATION_EDITOR_TRAINING_ROOM_ASSIGNED_PLAYERS | translate }}</mat-label>
						<mat-select
							(ngModelChange)="addDigitalSignagePlayer($event)"
							[(ngModel)]="selectedDigitalSignagePlayer"
							style="width: 100%"
						>
							@for (player of availableDigitalSignagePlayerList ?? filterAvailableDigitalSignagePlayerList(); track player) {
								<mat-option [value]="player">
									{{ player.name }}
								</mat-option>
							}
							<mat-option [value]="null">{{ T.CONFIGURATION_EDITOR_TRAININGROOM_NO_PLAYER | translate }}</mat-option>
						</mat-select>
					</mat-form-field>
				</sim-admin-settings-scroll-entries-con>
			</div>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="ok()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
